import * as types from '../mutation-types'

// initial state
const state = {
  shrink: false
}

// getters
const getters = {
  getShrink: state => state.shrink
}

// actions
const actions = {
  changeShrink ({ commit }, payload) {
    commit(types.CHANGE_SHRINK, payload)
  }
}

// mutations
const mutations = {
  [types.CHANGE_SHRINK] (state, payload) {
    state.shrink = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
